import { CSSProperties } from 'react'
import { Radio, Tooltip } from '@arco-design/web-react'
import classNames from 'classnames'
import styles from './index.module.less'

const RadioGroup = Radio.Group

interface DateItem {
  id: string | number
  title: string
  disabled?: boolean
  tooltip?: string
}

interface Props<T> {
  data: DateItem[]
  value: T
  setValue: (val: T) => void
  style?: CSSProperties
  type?: string
}

function EchoRadioGroup<T>({ data, value, setValue, style, type }: Props<T>) {
  return (
    <RadioGroup
      type="button"
      name="lang"
      value={value}
      onChange={setValue}
      className={classNames({
        [styles['container']]: type !== 'divide',
        [styles['container-divide']]: type === 'divide'
      })}
      style={style}
    >
      {data?.map((dateItem) => {
        if (dateItem.tooltip) {
          return (
            <Tooltip content={dateItem.tooltip} key={dateItem.id}>
              <Radio value={dateItem.id} disabled={dateItem.disabled}>
                {dateItem.title}
              </Radio>
            </Tooltip>
          )
        }
        return (
          <Radio key={dateItem.id} value={dateItem.id} disabled={dateItem.disabled}>
            {dateItem.title}
          </Radio>
        )
      })}
    </RadioGroup>
  )
}

export default EchoRadioGroup
